module.exports = __webpack_public_path__ + "img/wallet-icon-modal.5bd13377.svg";